import { Publication } from '@interfaces/publications-page';

const defaultValues = {
    previewImage: '',
    image: '/no-record.png',
    backgroundColor: '#222348'
};

export default function (publication: Publication) {
    if (!publication.themes) {
        return defaultValues;
    }

    const theme = (publication.themes.find(({ image: img }) => !!img) || ({} as any));

    return { ...defaultValues, ...theme };
}
